import theme from "Theme/AppTheme";

export const blueButtonWhiteBackgroundStyle = {
    color: theme.palette.blue.main,
    backgroundColor: theme.palette.white.main,
    border: "0.5px solid",
    borderColor: theme.palette.grey[200],
};
